"use strict";

var _slicedToArray = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = Value;

var _react = _interopRequireDefault(require("react"));

var _useLDflex = _interopRequireDefault(require("../hooks/useLDflex"));
/** Displays the value of a Solid LDflex expression. */


function Value(_ref) {
  var src = _ref.src,
      children = _ref.children;

  var _ref2 = (0, _useLDflex.default)(src),
      _ref3 = _slicedToArray(_ref2, 3),
      value = _ref3[0],
      pending = _ref3[1],
      error = _ref3[2]; // Render stringified value


  if (value !== undefined && value !== null) return "".concat(value); // Render pending state
  else if (pending) return children || _react.default.createElement("span", {
      className: "solid value pending"
    }); // Render error state
    else if (error) return children || _react.default.createElement("span", {
        className: "solid value error",
        "data-error": error.message
      }); // Render empty value
      else return children || _react.default.createElement("span", {
          className: "solid value empty"
        });
}